<template>
  <i-box class="insights-unit">
    <span slot="title">
      <div class="unit-head">
        <el-popover v-if="hasValidData" width="260" placement="bottom-end" trigger="hover">
          <span slot="reference" class="fa fa-info-circle pull-right" />
          <span popper-class="text-format-wrap" slot>{{
              dataByPeriod.description.replace(`the business account's`, `your account's`),
          }}</span>
        </el-popover>
        <h5 class="unit-title" @click="handleTitleClick">{{ dataByPeriod.title }}</h5>
      </div>
    </span>
    <span slot="content">
      <div v-if="hasValidData">
        <h1 class="no-margins">{{ Math.round(dataByPeriod.value).toLocaleString() }}</h1>
        <div
          class="stat-percent font-bold"
          :class="{
            'text-success': dataByPeriod.difference > 0,
            'text-danger': dataByPeriod.difference < 0,
            'text-muted': dataByPeriod.difference === 0,
          }"
        >
          {{ dataByPeriod.difference > 0 ? '+' : '' }}{{ dataByPeriod.difference.toLocaleString() }}
          <el-tooltip :content="`compared to previous ${period}`" placement="top">
            <i
              class="fa"
              :class="{
                'fa-level-up': dataByPeriod.difference > 0,
                'fa-level-down': dataByPeriod.difference < 0,
                'fa-minus': dataByPeriod.difference === 0,
              }"
            />
          </el-tooltip>
        </div>
        <div class="sparkline">
          <trend
            :data="dataByPeriod.values"
            :gradient="['#683090', '#c97eff']"
            :height="60"
            auto-draw
          />
        </div>
      </div>
      <div v-else class="no-data-placeholder">
        <h3 class="text-muted">-</h3>
      </div>
    </span>
  </i-box>
</template>

<script>
import Trend from 'vuetrend';
import IBox from '@/components/common/IBox';

const getDifference = (a, b) => (a || 0) - (b || 0);

export default {
  name: 'InsightsOverviewItem',

  components: {
    Trend,
    IBox,
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    period: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    periodDays: {
      day: 1,
      week: 7,
      month: 28,
    },
  }),

  computed: {
    hasValidData() {
      return (
        this.data &&
        this.data.values &&
        Array.isArray(this.data.values) &&
        this.data.values.length > 0
      );
    },

    dataByPeriod() {
      if (!this.hasValidData) {
        return {
          title: 'No Data',
          description: '',
          values: [],
          value: 0,
          difference: 0,
        };
      }

      const endIdx = this.data.values.length;
      const days = this.periodDays[this.period];
      const curStartIdx = Math.max(0, endIdx - days);
      const preStartIdx = Math.max(0, endIdx - days * 2);

      const currentPeriodValues = this.data.values.slice(curStartIdx, endIdx);
      const currentPeriodValue = currentPeriodValues.reduce((a, x) => a + (x.value || 0), 0);
      const previousPeriodValues = this.data.values.slice(preStartIdx, curStartIdx);
      const previousPeriodValue = previousPeriodValues.reduce((a, x) => a + (x.value || 0), 0);

      return {
        ...this.data,
        values: currentPeriodValues,
        difference: getDifference(currentPeriodValue, previousPeriodValue),
        value: currentPeriodValue,
      };
    },
  },

  methods: {
    isBetween(value, start, end) {
      return value >= start && value <= end;
    },

    handleTitleClick() {
      // this.$emit('onNavigate');
    },
  },

  watch: {
    data(newVal, oldVal) {
      if (newVal !== oldVal) this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss" scoped>
$my-text-color: #676a6c;

.unit-head {
  color: $my-text-color;

  .fa {
    font-size: 1.2em;
    margin-right: 0.8em;
  }
}

.unit-title {
  color: $my-text-color;
  // cursor: pointer;
}

.card-head {
  font-size: 1.3em;
}

.clearfix:after {
  clear: both;
}

.box-head {
  height: 1.5em;
}

.card-content {
  margin: 0px;
}
</style>


// WEBPACK FOOTER //
// InsightsOverviewItem.vue?55160c6e